import {
  Box,
  Checkbox,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Tooltip
} from '@mui/material';
import DateRange from 'src/components/common/DateRange';
import React, { Component, useEffect, useState } from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';

function CreateAppointmentEmployeesToolbar({ setFilters }) {
  let dateRangeValue = [];

  function handleFilter(value) {
    dateRangeValue = value;
  }

  function onRefresh() {
    if (dateRangeValue && dateRangeValue[0] && dateRangeValue[1])
      setFilters({
        dateRange: dateRangeValue
      });
  }

  return (
    <Grid container>
      <Grid item xs={12} sm={3}>
        <DateRange
          helperTextValue={'Created Date'}
          boxsize="small"
          onDateChange={(value) => {
            handleFilter(value);
          }}
        />
      </Grid>
      <Grid item>
        <Tooltip title="Refresh">
          <IconButton
            size="small"
            sx={{ boxShadow: '0 0 4px rgba(0,0,0,0.20)', marginLeft: '20px' }}
            onClick={() => onRefresh()}
            color="primary"
            aria-label="refresh"
          >
            {' '}
            <Refresh />{' '}
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
}

export default CreateAppointmentEmployeesToolbar;
